import { useQuery } from "react-query";
import { fetchPatientTags, fetchCustomFields } from "@/services/patient-tags";
/** Query hook for the patient's saved tag values. */
export function usePatientTagsQuery(patientUid) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useQuery(["patient-tags", patientUid], function () {
    return fetchPatientTags(patientUid);
  }, {
    enabled: Boolean(patientUid) && enabled
  });
}

/** Query hook for the workspace's custom field definitions. */
export function useCustomFieldsQuery(workspaceId) {
  return useQuery(["custom-fields", workspaceId], function () {
    return fetchCustomFields(workspaceId);
  }, {
    enabled: Boolean(workspaceId)
  });
}